import * as React from 'react';
import { kebabCase } from 'lodash';
import styles from './AssetAllocationChartTable.module.scss';
import DonutChartTable from '../charts/DonutChartTable';
import { DONUT_CHART_DEFAULT_OPTIONS } from '../../utils/constants';

type Props = {
  className: string;
  selectedAccount: AssetAccount;
};

const AssetAllocationChartTable: React.FC<Props> = ({
  className,
  selectedAccount
}) => {
  if (selectedAccount === undefined) {
    return null;
  }

  const { assets } = selectedAccount.dailyReport;

  const data: DataPoints = assets.map((asset) => ({
    label: asset.assetName,
    value: asset.assetTotal.percentOfPortfolio,
    style: `${styles[kebabCase(`${asset.assetName}-chart`)]}`
  }));

  const dataPoints: DataPoints = assets.map((asset) => ({
    label: asset.assetName,
    value: asset.assetTotal.percentOfPortfolio,
    style: styles[kebabCase(asset.assetName)]
  }));

  const chartOptions = {
    ...DONUT_CHART_DEFAULT_OPTIONS,
    classNames: data.map((datum) => `${datum.style}`)
  };

  return (
    <DonutChartTable
      tableType="Asset Allocation"
      tableTitle="Percent of Portfolio"
      tableTitleClassName={styles['table-title']}
      chartOptions={chartOptions}
      dataPoints={dataPoints}
      className={className}
      donutChartClassName={styles['donut-chart']}
      displayDecimalPlace={true}
    />
  );
};

export default AssetAllocationChartTable;
